// User needs to be able to save to local storage else state will be initial state
export const loadState = (initialState) => {
  try {
    const prevState = localStorage.getItem('state');
    const newState = localStorage.getItem('revue.state'); 
    if (newState && prevState) { // If user has both old and new name, clear the old name.
      localStorage.removeItem('state');
    }
    const serializedState = newState || prevState; // Look for old name if user does not yet have new name
    if (serializedState === null) {
      return initialState;
    }
    const parsedState = JSON.parse(serializedState);
    delete parsedState.exploreMap; // Remove old unused explore state
    const combinedState = {
      ...initialState,
      ...parsedState,
      dashboardState: {
        ...initialState.dashboardState,
        ...parsedState.dashboardState,
        rentalInventory: {
          ...initialState.dashboardState.rentalInventory,
          ...parsedState.dashboardState.rentalInventory
        },
        retailInventory: {
          ...initialState.dashboardState.retailInventory,
          ...parsedState.dashboardState.retailInventory
        }
      },
      channelWorkflowState: {
        ...initialState.channelWorkflowState,
        ...parsedState.channelWorkflowState
      },
      postAcqWorkflowState: {
        ...initialState.postAcqWorkflowState,
        ...parsedState.postAcqWorkflowState
      }
    }
    return combinedState;
  } catch (err) {
    console.log(err);
    return initialState;
  }
}
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('revue.state', serializedState); // Renamed 'state' to 'revue.state', added handling in loadState fn for both names
  } catch (err) {
    console.log(err);
  }
} 